import { getTrackingId } from "./track";
import axiosResiInstance from "../http/axiosResi";

export const LEAD_TYPE_CONTACT = "contact";
export const LEAD_TYPE_GET_MORE_INFO = "get_more_info";
export const LEAD_TYPE_LISTING = "listing";

export const LEAD_TYPES = [
    { value: LEAD_TYPE_CONTACT, label: "Contact" },
    { value: LEAD_TYPE_GET_MORE_INFO, label: "Get More Info" },
    { value: LEAD_TYPE_LISTING, label: "Listing" },
];

export const LEAD_TYPE_LABELS = {
    [LEAD_TYPE_CONTACT]: "Contact",
    [LEAD_TYPE_GET_MORE_INFO]: "Get More Info",
    [LEAD_TYPE_LISTING]: "Listing",
};

export const LEAD_ONLY_CONTACT_TYPES = [
    { value: LEAD_TYPE_CONTACT, label: "Contact" },
];

export const LEAD_POST_URLS = {
    [LEAD_TYPE_CONTACT]: "contact",
    [LEAD_TYPE_GET_MORE_INFO]: "get-more-info",
    [LEAD_TYPE_LISTING]: "listing",
};

export const postLead = async (type, data, isTest = false) => {
    const trackingId = await getTrackingId();

    if (trackingId) {
        data.tracking_id = trackingId;
    }

    if (isTest) {
        data.is_test = 1;
    }

    return axiosResiInstance
        .post(`/lead/${LEAD_POST_URLS[type]}`, data)
        .then((res) => {
            trackConversion();
            return res;
        });
};

export const trackConversion = () => {
    import("react-facebook-pixel")
        .then((x) => x.default)
        .then((ReactPixel) => {
            ReactPixel.track("Lead");
        });
};
